import type { PublicTransactionSummaryModel } from "@/features/collections/api/models/PublicTransactionSummaryModel";
import type { PublicTransactionSummariesSortOrder } from "@/features/collections/PublicTransactionSummariesSortOrder";
import type { Currency } from "@/lib/domain/Currency";
import type { PriceSource } from "@/lib/domain/PriceSource";
import { useHTTP, type PaginatedResponseModel } from "@/lib/http";
import { useHTTPQueryWithCursor } from "@/lib/http/useHTTPQueryWithCursor";

export const usePublicTransactionSummariesByShareToken = (shareToken: string, currency: Currency, priceSource: PriceSource, productNameFilter: string, sort: PublicTransactionSummariesSortOrder) => {
	const http = useHTTP("UseIfPresent");
	return useHTTPQueryWithCursor({
		queryKey: ["publicTransactionSummaries", shareToken, currency, priceSource, sort, productNameFilter],
		queryFn: ({ pageParam }) => {
			return http<PaginatedResponseModel<PublicTransactionSummaryModel>>({
				method: "GET",
				url: `/collection/public/${shareToken}/transaction-summaries?cursor=${pageParam}&currency=${currency}&priceSource=${priceSource}&sort=${sort}` + (productNameFilter.trim() ? `&productNameFilter=${encodeURIComponent(productNameFilter)}` : "")
			});
		}
	});
};
